import type { FC } from 'react';

import { StyledContainer, StyledContent, StyledLink, StyledTitle } from './styles';

type Props = {
  title: string;
  content: string;
  buttonText?: string;
  onButtonClick?: VoidFunction;
};

export const QuotaInfoTooltipContent: FC<Props> = ({ title, content, buttonText, onButtonClick }) => (
  <StyledContainer>
    <StyledTitle>{title}</StyledTitle>
    <StyledContent>{content}</StyledContent>

    {buttonText ? <StyledLink onClick={onButtonClick}>{buttonText}</StyledLink> : null}
  </StyledContainer>
);
